export const BACKEND_ENDPOINT =
  "https://bx9wr5htzi.execute-api.ap-south-1.amazonaws.com/dev";

export const GET_DEVICE_DETAIL = "/vcs/services/accounts/devices/getDeviceDetails"
export const UPDATE_DEVICE = "/vcs/services/accounts/devices/updateDevice"
export const DELETE_DEVICE = "/vcs/services/accounts/devices/deleteDevice"
export const CREATE_DEVICE = "/vcs/services/accounts/devices/createDevice"
export const GET_DEVICE = "/vcs/services/accounts/devices/getDevices"

export const GET_REQUEST_DETAIL = "/vcs/services/thruststand/requests/getRequestDetails"
export const UPDATE_REQUEST = "/vcs/services/thruststand/requests/updateRequest"
export const DELETE_REQUEST = "/vcs/services/thruststand/requests/deleteRequest"
export const CREATE_REQUEST = "/vcs/services/thruststand/requests/createRequest"
export const GET_REQUESTS = "/vcs/services/thruststand/requests/getRequests"

